import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class MotivosService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/motivos/${this.idconta}`)

    return response.data
  }

  async getByCodigo(codigo) {
    const response = await apinode.get(`/motivos/${codigo}/${this.idconta}`)

    return response.data
  }

  async search({ type, text }) {
    const url = unifyParams(`/motivos/search/${this.idconta}`, [
      {
        key: type,
        value: text,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async create(data) {
    await apinode.post(`/motivos/${this.idconta}`, data)
  }

  async update(codigo, data) {
    await apinode.put(`/motivos/${codigo}/${this.idconta}`, data)
  }

  async delete(codigo) {
    await apinode.delete(`/motivos/${codigo}/${this.idconta}`)
  }
}

export default new MotivosService()
